// Login-Seite: Passwortsichtbarkeit und Anmeldung ohne Seitenwechsel.
// Teil des Entrys auth (scripts/auth.js); greift nur, wenn [data-login-form]
// im Markup steht.
//
// Der Server bleibt unangetastet — das Formular geht als ganz normaler POST
// an app_login, nur eben per fetch. Symfony antwortet darauf wie immer mit
// einem Redirect: bei Erfolg auf das Ziel, bei Fehlschlag zurueck auf die
// Login-Seite, deren gerenderte Fehlerbox wir aus der Antwort auslesen.
//
// Ohne JavaScript passiert nichts davon und das Formular verhaelt sich wie
// vorher: submit, Seitenwechsel, Fehlerbox im Markup.
import Swal from 'sweetalert2';

function initPasswordToggles() {
  document.querySelectorAll('[data-password-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var field = document.getElementById(toggle.dataset.passwordToggle);
      var icon = toggle.querySelector('i');
      var shown = field.type === 'text';

      field.type = shown ? 'password' : 'text';
      icon.classList.toggle('fa-eye', shown);
      icon.classList.toggle('fa-eye-slash', !shown);
    });
  });
}

function initLoginForm() {
  var form = document.querySelector('[data-login-form]');

  if (!form) {
    return;
  }

  var submit = form.querySelector('[data-login-submit]');
  var icon = form.querySelector('[data-login-icon]');
  // Alles, was waehrend des Ladens nicht bedienbar sein soll. Der
  // Sichtbarkeitsschalter gehoert dazu: er zeigt sonst ein Passwort, das
  // ohnehin schon unterwegs ist.
  var controls = form.querySelectorAll('input:not([type="hidden"]), [data-password-toggle]');
  var texts = form.dataset;
  var busy = false;

  function setBusy(state) {
    busy = state;
    submit.disabled = state;
    controls.forEach(function (control) {
      control.disabled = state;
    });
    icon.classList.toggle('fa-chevron-right', !state);
    icon.classList.toggle('fa-spinner-third', state);
    icon.classList.toggle('fa-spin', state);
  }

  // Die Antwort ist eine frisch gerenderte Login-Seite. Falls deren CSRF-Token
  // ein anderes ist als unseres, braucht der naechste Versuch genau das.
  function refreshToken(doc) {
    var fresh = doc.querySelector('input[name="_csrf_token"]');
    var current = form.querySelector('input[name="_csrf_token"]');

    if (fresh && current) {
      current.value = fresh.value;
    }
  }

  function fail(message) {
    setBusy(false);

    Swal.fire({
      icon: 'error',
      title: texts.errorTitle,
      text: message,
      confirmButtonText: texts.errorConfirm,
    }).then(function () {
      var password = form.querySelector('input[type="password"]');
      if (password) {
        password.value = '';
        password.focus();
      }
    });
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (busy) {
      return;
    }

    // Vor setBusy(): ein deaktiviertes Feld liefert keinen Wert an FormData.
    var body = new FormData(form);
    setBusy(true);

    fetch(form.action, {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (response) {
        return response.text().then(function (html) {
          return {
            url: response.url,
            ok: response.ok,
            redirected: response.redirected,
            document: new DOMParser().parseFromString(html, 'text/html'),
          };
        });
      })
      .then(function (result) {
        var error = result.document.querySelector('.auth__error');

        if (error) {
          refreshToken(result.document);
          fail(error.textContent.trim() || texts.errorGeneric);

          return;
        }

        // Kein Redirect und kein Erfolgsstatus: die Anmeldung ist gar nicht
        // erst durchgelaufen (Serverfehler). Dorthin zu navigieren wuerde die
        // Login-Seite kommentarlos neu laden.
        if (!result.ok && !result.redirected) {
          refreshToken(result.document);
          fail(texts.errorGeneric);

          return;
        }

        // Angemeldet. Die Antwort ist bereits die Zielseite — wir werfen sie
        // weg und lassen den Browser dorthin navigieren, damit Verlauf und
        // Adresszeile stimmen. Ein Fehler AUF der Zielseite ist deren Sache,
        // nicht die des Logins.
        var target = new URL(result.url || '/', window.location.origin);
        window.location.href = target.origin === window.location.origin ? target.href : '/';
      })
      .catch(function () {
        fail(texts.errorNetwork);
      });
  });
}

initPasswordToggles();
initLoginForm();
